export default function Box({ children }) {
  return <div className="auth__box twy-bg-base-accent">
    {children}
  </div>
}
